module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-background-wasou-67a7a1cbb185a1714d1ae0cc937d766a.jpg";